import { Box, Span, VStack } from '@bpba/ui-components';
import { SyntheticEvent, useState } from 'react';
import { IconBaseProps, IconType } from 'react-icons';
import { FaCircleQuestion } from 'react-icons/fa6';
import styled from 'styled-components';
import { background, BackgroundProps, color, ColorProps, display, DisplayProps, position, PositionProps, space, SpaceProps } from 'styled-system';
import { StyledBox } from './StyledBox';

const ICON_SIZE = 16;

export const InfoTooltip = (message: string, positionLeft?: number[], marginBottom?: number, marginTop?: number, textVisible: boolean = true): IconType => {
  const [show, setShow] = useState<boolean>(false);

  const toggleTooltip = (event: React.TouchEvent) => {
    setShow((current) => !current);

    event.stopPropagation();
  };

  const closeMobileTooltip = (event: SyntheticEvent) => {
    setShow(false);

    event.stopPropagation();
    event.preventDefault();
  };

  if (!message) return () => <Box width="21px" marginLeft="8px" />;

  return (props: IconBaseProps) => (
    <VStack color="tertiary.0" marginBottom={marginBottom} marginTop={marginTop} width="fit-content" marginLeft={'8px'} position="unset" aria-label={message}>
      {/**Tooltip sólo para tablet y mobile. Cuando el texto se muestra fijo a la derecha, se deshabilita este tooltip. */}
      {show && (
        <MobileTooltipContainer
          left={positionLeft}
          onTouchEnd={closeMobileTooltip}
          onClick={closeMobileTooltip}
          aria-hidden="true"
          color="black"
          display={textVisible ? ['block', 'none'] : 'block'}
        >
          {message}
        </MobileTooltipContainer>
      )}

      <StyledBox gap="8px" flexDirection={'row'} width={'100%'} justifyContent="center" alignItems="center" height={ICON_SIZE} aria-hidden="true">
        <QuestionCircle title={message} {...props} onTouchStart={toggleTooltip} onTouchCancel={closeMobileTooltip} />
        <Span fontSize={'12px'} display={textVisible ? ['none', 'flex'] : 'none'}>
          {message}
        </Span>
      </StyledBox>
    </VStack>
  );
};

type MobileTooltipContainerProps = SpaceProps & PositionProps & BackgroundProps & ColorProps & DisplayProps;
const MobileTooltipContainer = styled.span<MobileTooltipContainerProps>(space, position, background, color, display, {
  position: 'absolute',
  bottom: 48,
  zIndex: 1,
  padding: '8px 12px',
  backgroundColor: 'white',
  borderStyle: 'solid',
  borderWidth: '1px',
  borderColor: 'black',
  width: '90%',
  lineHeight: '20px',
  textAlign: 'justify',
  boxShadow: '0px 0px 8px 2px rgba(0,0,0,0.4)',
  whiteSpace: 'pre-wrap',
});

const QuestionCircle = styled(FaCircleQuestion)`
  height: 21px;
  width: 21px;
`;
